import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingsService, UpdateEditListData, UpdateListData, UpdateListElementData, UpdateListOptions, listoptions } from '../settings.service';
import { DropdownSelectionMode, DropdownValue, DropdownValues } from 'src/app/widgets/dropdown/dropdown.component';

import { DxDataGridComponent, DxValidationGroupComponent, DxValidatorComponent } from 'devextreme-angular';
import { EditingStartEvent } from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-list-options',
    templateUrl: './list-options.component.html',
    styleUrl: './list-options.component.scss',
    standalone: false
})
export class ListOptionsComponent implements OnInit {
  listnames: listoptions[] = [];
  listDropdown: DropdownValues = new DropdownValues();
  listelementsItems: any
  selectedListId: number;
  listelementdata: any;
  changedtableValuesDataSourceRecords = [];
  changedListValuesDataSourceRecords = [];
  showInfoPopup: boolean;
  infoPopupMessage: string;
  infPopupTitle: string;


  listItem: UpdateListOptions;
  addListElementPopup = false;
  addListPopup=false;
  listelement: string;
  listelementgroupname: string;
  sorOrder: number;
  listelemntsavedata: UpdateListElementData;
  selectedInputs: UpdateListOptions[] = [];
  proceedingInfoPopup = false;
  proceedingListInfoPopup = false;
  listelementdeletedata: UpdateListElementData;
  allowUpdating: boolean = false;
  editPopup: boolean = false;
  listData: listoptions[];
  listsavedata: UpdateListData;
  updatedlistitems: UpdateEditListData;
  listname:string;
  defaultlistelementid:number;
  newlistdata: UpdateEditListData;
  deletelistdataid: number;
  deletelistname: string;

  constructor(
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.getListData();  
  }

  getListData() {
      this.settingsService.getListNames({ showLoadingIndicator: true }).subscribe((data) => {
        this.listnames = data;
        if (this.listnames.length > 0) {
          this.selectedListId = this.listnames[0].listId;
          this.prepareRolesDropdownValues();
          this.getListElementById();
        }
      });
  }

  handleEditingStart(e: EditingStartEvent) {
    if (e.data.listElementId < 0) {
      e.cancel = true;
    }
  }

  handleListEditingStart(e){
    if (e.column.dataField === 'listId' || e.data.listId < 0) {
      e.cancel = true;
    }
  }

  private prepareRolesDropdownValues() {
    this.listDropdown = new DropdownValues();
    this.listDropdown.selectionMode = DropdownSelectionMode.single;
    this.listDropdown.showClearButton = false;
    this.listDropdown.displayName = 'List';
    this.listDropdown.values = this.listnames.map((listdata) => new DropdownValue(listdata.listId, listdata.listName+' '+'('+listdata.listId+')'));
  }

  getListElementById() {
    this.settingsService.getListElementById(this.selectedListId).subscribe((data) => {
      this.listelementdata = data;
    })
  }

  public onlistChanged(listid: number) {
    this.selectedListId = listid;
    this.getListElementById();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    toolbarItems.unshift({
      location: 'after',
      template: 'saveButtonTemplate'
    }, {
      location: 'after',
      template: 'undoButtonTemplate'
    }, {
      location: 'after',
      template: 'addListButtonTemplate'
    }, {
      location: 'after',
      template: 'deleteListButtonTemplate'
    }
    );
  }

  unsavedChanges = false;
  onRowUpdating(e) {
		const updatedRow = { ...e.oldData, ...e.newData };
		this.unsavedChanges = true;
		this.addOrReplace(updatedRow);
	}

  onListElementEditorPrepared(event: any) {
		if (event.parentType === "dataRow" && event.dataField) {
				event.editorElement.addEventListener("input", this.debounce((e: Event) => {
				const newValue = (e.target as HTMLInputElement).value;
          if (newValue  !== event.row.data[event.dataField]) {
            this.unsavedChanges = true;
            // Commit the value to the grid's data source
            event.setValue(newValue); // Required for grid to track the change
          }
				}, 300));
		}
	}

	private debounce(func: Function, wait: number) {
		let timeout: any;
		return function(...args: any) {
		  clearTimeout(timeout);
		  timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

  arrIndex = {};
  addOrReplace(object) {
    if(object.listElementId){
    let index = this.changedtableValuesDataSourceRecords.findIndex((item: any) => item.listElementId === object.listElementId);
    	if (index === -1) {
    	    this.changedtableValuesDataSourceRecords.push(object);
    	} else {
    	    this.changedtableValuesDataSourceRecords[index] = object;
    	}
    }
  }
  
  unsavedlistChanges = false;

  editlistgridRowUpdating(e) {
		const updatedRow = { ...e.oldData, ...e.newData };
		this.unsavedlistChanges = true;
		this.addOrReplaceList(updatedRow);
	}

  onListEditorPrepared(event: any) {
		if (event.parentType === "dataRow" && event.dataField) {
				event.editorElement.addEventListener("input", this.debounce((e: Event) => {
				const newValue = (e.target as HTMLInputElement).value;
        if (newValue  !== event.row.data[event.dataField]) {
          this.unsavedlistChanges = true;
          // Commit the value to the grid's data source
          event.setValue(newValue); // Required for grid to track the change
        }
				}, 300));
		}
	}

  arrListIndex = {};
  addOrReplaceList(object) {
    if(object.listId){
      let index = this.changedListValuesDataSourceRecords.findIndex((item: any) => item.listId === object.listId);
        if (index === -1) {
            this.changedListValuesDataSourceRecords.push(object);
        } else {
            this.changedListValuesDataSourceRecords[index] = object;
        }
    }
  }

  changeInfoPopupStatus() {
    this.showInfoPopup = false;
    this.infoPopupMessage = '';
    this.infPopupTitle = '';
  }

  saveAllChanges() {
    this.dataGrid.instance.saveEditData().then(() => {
    if (this.unsavedChanges) {
      this.listelemntsavedata = new UpdateListElementData();
      this.listelemntsavedata.listdata = [];
      this.changedtableValuesDataSourceRecords.forEach(item => {
        this.listItem = new UpdateListOptions();
        this.listItem.listElementId = item.listElementId;
        this.listItem.listElement = item.listElement;
        this.listItem.sortOrder = item.sortOrder;
        this.listItem.listElementGroup = item.listElementGroup1 === '' ? null : item.listElementGroup1;
        this.listItem.listId = item.listId;
        this.listelemntsavedata.listdata.push(this.listItem);
      });
      this.listelemntsavedata.action = 'update'

      this.settingsService.UpdateListElement(this.listelemntsavedata).subscribe(result => {
        this.infoPopupMessage = 'Changes Saved Successfully!';
        this.infPopupTitle = 'Saved';
        let flag = 0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          flag = result.returnFlag[0].flag;
        }
        this.showInfoPopup = true;
        this.unsavedChanges = false;
        this.changedtableValuesDataSourceRecords = [];
        this.getListElementById();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);

      }, (error) => {
          console.error(error);
      });

    } else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'No changes have been done yet.';
      this.infPopupTitle = 'Warning';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  });
  }

  @ViewChild('editingDataGrid', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('editingListDataGrid', { static: false }) listdataGrid: DxDataGridComponent;

  undoAllChanges() {
    if (this.unsavedChanges) {
      this.dataGrid.instance.beginCustomLoading('Reverting changes');
      this.dataGrid.instance.closeEditCell();
      this.getListElementById();
      this.unsavedChanges = false;
      this.changedtableValuesDataSourceRecords = [];
      this.dataGrid.instance.endCustomLoading();
    } else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'No changes have been done yet.';
      this.infPopupTitle = 'Warning';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  }

  resetListElementValidation(){
    if (this.listElementValidationGroup) {
      this.listElementValidationGroup.instance.reset();
    }
  }

  resetListNameValidation(){
    if (this.listNameValidationGroup) {
      this.listNameValidationGroup.instance.reset();
    }
  }
  addNewListElement() {
    this.addListElementPopup = true;
  }
  addNewList(){
    this.addListPopup=true;
  }
  onCancelClick() {
    this.addListElementPopup = false;
    this.resetlistelement();
  }
  onCancel(){
    this.addListPopup=false;
    this.resetlist();
  }
  saveNewListElement(e) {
    this.listelemntsavedata = new UpdateListElementData();
    this.listelemntsavedata.listdata = [];
    this.listItem = new UpdateListOptions();
    if (this.listelement != null && this.listelement != undefined) {
      this.listItem.listElement = this.listelement;
      this.listItem.sortOrder = this.sorOrder === undefined ? null : this.sorOrder;
      this.listItem.listElementGroup = this.listelementgroupname === undefined ? null : this.listelementgroupname;
      this.listItem.listId = this.selectedListId;
      this.listelemntsavedata.listdata.push(this.listItem);
      this.listelemntsavedata.action = 'insert'

      this.settingsService.UpdateListElement(this.listelemntsavedata).subscribe(result => {
        this.infoPopupMessage = 'List Element Added Successfully!';
        this.infPopupTitle = 'Added';
        let flag = 0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          flag = result.returnFlag[0].flag;
        }
        this.showInfoPopup = true;
        this.unsavedChanges = false;
        this.changedtableValuesDataSourceRecords = [];
        if (flag > 0) {
          this.addListElementPopup = false;
        }
        this.getListElementById();
        this.resetlistelement();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);

      }, (error) => {
          console.error(error);
      });
    }
    else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'Please enter List Element Name';
      this.infPopupTitle = 'Error';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  }

  gridSelectionChanged(data: any) {
    this.selectedInputs = [];
    data.selectedRowKeys.forEach(element => {
      if (element.listElementId > 0) {
          if (!this.selectedInputs.includes(element)) {
              this.selectedInputs.push(element);
          }
      } else {
          data.component.deselectRows(element);
      }
  });
  }

  onCellPrepared(e: any) {
    if (e.rowType === 'data' && e.column.command === 'select' && e.data.listElementId < 0) {
      setTimeout(() => {
          const checkboxElement = e.cellElement.querySelector('.dx-checkbox-icon');
          if (checkboxElement) {
              checkboxElement.style.backgroundColor = '#d3d3d3'; // Grey
              checkboxElement.style.pointerEvents = 'none';
              checkboxElement.style.opacity = '0.6';
          }
      });
    }
  }

  DeletePopup() {
    this.proceedingInfoPopup = true;
  }

  deleteSelectedInputs() {
    this.listelementdeletedata = new UpdateListElementData();
    this.listelementdeletedata.listdata = [];
    this.selectedInputs.forEach(item => {
      this.listItem = new UpdateListOptions();
      this.listItem.listElementId = item.listElementId;
      this.listItem.listId = item.listId;
      this.listItem.listElement = item.listElement;
      this.listelementdeletedata.listdata.push(this.listItem);
    });
    this.listelementdeletedata.action = 'delete'

    this.settingsService.UpdateListElement(this.listelementdeletedata).subscribe(result => {
      this.infoPopupMessage = 'List Element Deleted Successfully!';
      this.infPopupTitle = 'Deleted';
      let flag=0;
      if (result.returnFlag.length > 0) {
        this.infoPopupMessage = result.returnFlag[0].msg;
        this.infPopupTitle = result.returnFlag[0].retrunData;
        flag=result.returnFlag[0].flag;
      }
      this.showInfoPopup = true;
      this.proceedingInfoPopup = false;
      this.selectedInputs = [];
      this.getListElementById();
      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 5000);
    }, (error) => {
        console.error(error);
    });
  }

  openEditPopup(action: string) {
    if (action == 'open') {
      this.editPopup = true;
    } else {
      this.editPopup = false;
    }
  }

  saveEditListChanges() {
    this.listdataGrid.instance.saveEditData().then(() => {
    if (this.unsavedlistChanges) {
      this.listsavedata = new UpdateListData();
      this.listsavedata.listnewdata = [];
      this.changedListValuesDataSourceRecords.forEach(item => {
        this.updatedlistitems = new UpdateEditListData();
        this.updatedlistitems.listId = item.listId;
        this.updatedlistitems.listName = item.listName;
        this.updatedlistitems.defaultListElementId = item.defaultListElementId === ' ' ? null : item.defaultListElementId;
        this.listsavedata.listnewdata.push(this.updatedlistitems);
      });
      this.listsavedata.action = 'update';

      this.settingsService.UpdateList(this.listsavedata).subscribe(result => {
        this.infoPopupMessage = 'Changes Saved Successfully!';
        this.infPopupTitle = 'Saved';
        let flag = 0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          flag = result.returnFlag[0].flag;
        }
        this.showInfoPopup = true;
        this.unsavedlistChanges = false;
        this.changedListValuesDataSourceRecords = [];
        this.getListData();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);

      }, (error) => {
          console.error(error);
      });

    } else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'No changes have been done yet.';
      this.infPopupTitle = 'Warning';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  });
  }

  saveNewList(){
    this.listsavedata = new UpdateListData();
    this.listsavedata.listnewdata = [];
    this.newlistdata = new UpdateEditListData();
    if (this.listname != null && this.listname != undefined) {
      this.newlistdata.listName = this.listname;
      this.newlistdata.defaultListElementId = this.defaultlistelementid === undefined ? null : this.defaultlistelementid;
      this.listsavedata.listnewdata.push(this.newlistdata);
      this.listsavedata.action = 'insert';
      
      this.settingsService.UpdateList(this.listsavedata).subscribe(result => {
        this.infoPopupMessage = 'List Added Successfully!';
        this.infPopupTitle = 'Added';
        let flag = 0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          flag = result.returnFlag[0].flag;
        }
        this.showInfoPopup = true;
        this.unsavedlistChanges = false;
        this.changedListValuesDataSourceRecords = [];
        if (flag > 0) {
          this.addListPopup = false;
        }
        this.getListData();
        this.resetlist();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);

      }, (error) => {
          console.error(error);
      });
    }
    else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'Please enter List Name';
      this.infPopupTitle = 'Error';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  }

  @ViewChild("listElementValidationGroup", { static: false }) listElementValidationGroup: DxValidationGroupComponent;
  @ViewChild("listNameValidationGroup", { static: false }) listNameValidationGroup: DxValidationGroupComponent;

  resetlistelement() {
    this.listelement = null;
    this.listelementgroupname = null;
    this.sorOrder = null;
    if (this.listElementValidationGroup) {
      this.listElementValidationGroup.instance.reset();
    }
  }

  resetlist(){
    this.listname=null;
    this.defaultlistelementid=null;
    if (this.listNameValidationGroup) {
      this.listNameValidationGroup.instance.reset();
    }
  }

  showDeleteAlert(e){
    this.proceedingListInfoPopup = true;
    this.deletelistdataid=e.data.listId;
    this.deletelistname=e.data.listName;
  }

  deleteList(){
    if(this.deletelistdataid !=null && this.deletelistdataid !=undefined){
      this.settingsService.DeleteList(this.deletelistdataid).subscribe(result => {
        this.infoPopupMessage = 'List Deleted Successfully!';
        this.infPopupTitle = 'Deleted';
        let flag=0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          flag = result.returnFlag[0].flag;
        }
        this.showInfoPopup = true;
        this.proceedingListInfoPopup = false;
        this.deletelistdataid = null;
        this.deletelistname = null;
        this.getListData();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);
      }, (error) => {
          console.error(error);
      });
    }
  }
}
